export default __webpack_public_path__ + "static/media/warning--junction-with-a-side-road-perpendicular-left--g3.ac6cedd7.png";